'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var chicletTypes = require('./chicletTypes.js');
var chiclet_module = require('./chiclet.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Chiclet = function (_a) {
    var _b = _a.chicletType, chicletType = _b === void 0 ? chicletTypes.ChicletTypes.DEFAULT : _b, Icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? chicletTypes.IconPositionTypes.START : _c, displayText = _a.displayText, className = _a.className;
    return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default('p-1 px-2 d-inline-flex rounded justify-content-around align-items-center', chiclet_module.default['alloy-chiclet'], chiclet_module.default["chiclet-".concat(chicletType)], { 'flex-row-reverse': iconPosition === chicletTypes.IconPositionTypes.END }, className) }, { children: [Icon && jsxRuntime.jsx(Icon, { height: 18, width: 18 }), displayText && (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('p-1 px-2 text-uppercase text-center', chiclet_module.default['chiclet-text']) }, { children: displayText })))] })));
};
var Chiclet$1 = Chiclet;

exports.default = Chiclet$1;
//# sourceMappingURL=Chiclet.js.map
